module.exports = __webpack_public_path__ + "img/about-sms-img5.17bda0bc.png";